/* global Flickity */

const shape = 'M50.4648 2.22128C49.7661 1.51744 48.9347 0.958776 48.0187 0.577531C47.1027 0.196286 46.1202 0 45.1279 0C44.1356 0 43.1531 0.196286 42.2371 0.577532C41.3211 0.958777 40.4898 1.51744 39.791 2.22129L2.20699 39.3931C0.806981 40.8001 0.021164 42.7034 0.0211642 44.6873C0.0211644 46.6661 0.802938 48.5647 2.19618 49.9706C1.50448 50.663 0.954776 51.4839 0.578095 52.3872C0.196477 53.3022 0 54.2838 0 55.2751C0 56.2665 0.196477 57.248 0.578095 58.1631C0.959713 59.0782 1.51892 59.9087 2.22346 60.6068L39.4316 97.7787C40.1304 98.4825 40.9618 99.0412 41.8778 99.4224C42.7937 99.8037 43.7762 99.9999 44.7685 99.9999C45.7608 99.9999 46.7433 99.8037 47.6593 99.4224C48.5753 99.0412 49.4067 98.4825 50.1055 97.7787L2.23439 49.9543L50.4648 2.22128ZM100.004 54.1049L16.6836 54.1049V45.781L100.004 45.781V54.1049Z';

// Add and remove a resizing class to get equal height cells
const resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call( this );
  this.element.classList.add('flickity-resize');
};

// Initialize Flickity on panoramas
const initFlickity = (panoramas) => {
  panoramas.forEach((panorama) => {
    const flkty = new Flickity(panorama, {
      pageDots: false,
      freeScroll: true,
      freeScrollFriction: 0.1,
      imagesLoaded: true,
      cellAlign: 'center',
      contain: true,
      arrowShape: shape,
    });

    // Recalc position from unhide/lazy load
    window.addEventListener('load', () => {
      flkty.reloadCells();
      flkty.resize();
    });
  });
};

const init = () => {
  const panoramas = document.querySelectorAll('[data-ref="panorama"]');

  if (panoramas && panoramas.length) {
    initFlickity(panoramas);
  }
};

init();
